import {
  LoyaltyTagSection as LoyaltyTagSectionGrpc,
  LoyaltyTagSectionType as LoyaltyTagSectionTypeGrpc,
  Translation,
} from "gen/witbooking/loyalty/tag/v1/loyalty_tag_api_pb";
import { LoyaltyTagSection, LoyaltyTagSectionType } from "../../domain/LoyaltyTagSection";
import { LoyaltyTagSectionTableDto } from "../dto/LoyaltyTagSectionTableDto";
import { LoyaltyTagMapper } from "./LoyaltyTagMapper";

export class LoyaltyTagSectionMapper {
  static toTableDto(
    loyaltyTagSection: LoyaltyTagSection,
    locale: string
  ): LoyaltyTagSectionTableDto {
    return {
      id: loyaltyTagSection.id,
      ticker: loyaltyTagSection.ticker,
      order: loyaltyTagSection.order,
      name: loyaltyTagSection.getTranslation(locale).name,
      tags: loyaltyTagSection.tags.map(tag => tag.getTranslation(locale).name),
    };
  }

  static fromGrpc(grpc: LoyaltyTagSectionGrpc): LoyaltyTagSection {
    return LoyaltyTagSection.of({
      id: grpc.getId(),
      order: grpc.getOrder(),
      ticker: grpc.getTicker(),
      type: LoyaltyTagSectionType.PREFERENCE_SECTION,
      tags: grpc.getTagsList().map(LoyaltyTagMapper.fromGrpc),
      translations: grpc.getTranslationsList().map(t => ({
        locale: t.getLocale(),
        name: t.getTranslation(),
        description: t.getDescription(),
      })),
    });
  }

  static toGrpc(brandId: string, section: LoyaltyTagSection): LoyaltyTagSectionGrpc {
    const grpc = new LoyaltyTagSectionGrpc();
    grpc.setId(section.id);
    grpc.setOrder(section.order);
    grpc.setTicker(section.ticker);
    grpc.setBrandid(brandId);
    grpc.setType(LoyaltyTagSectionTypeGrpc.PREFERENCE_SECTION);
    grpc.setTagsList(section.tags.map(t => LoyaltyTagMapper.toGrpc(t, brandId)));
    grpc.setTranslationsList(
      section.translations.map(t => {
        const translation = new Translation();
        translation.setLocale(t.locale);
        translation.setTranslation(t.name);
        translation.setDescription(t.description ?? "");
        return translation;
      })
    );
    return grpc;
  }
}
